import { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollTotopButton";
import { ThemeProvider } from "./components/Themes/ThemeContext";

const HomePage = lazy(() => import("./components/HomePage"));
const Careers = lazy(() => import("./components/Careers"));
const Opportunities = lazy(() => import("./components/Opportunities"));
const JoinUs = lazy(() => import("./components/JoinUs"));
const OurElite = lazy(() => import("./components/OurElite"));
const OurFounders = lazy(() => import("./components/OurFounders"));
const Events = lazy(() => import("./components/Events"));
const Courses = lazy(() => import("./components/Courses"));
const Sponsors = lazy(() => import("./components/Sponsors"));
const Community = lazy(() => import("./components/Community"));
const Classes = lazy(() => import("./components/Classes"));
const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy"));
const Contact = lazy(() => import("./components/Contact"));
const About = lazy(() => import("./components/About"));
const Jobs = lazy(() => import("./components/Jobs"));
const Profile = lazy(() => import("./components/Profile"));
const Report = lazy(() => import("./components/Report"));
const Login = lazy(() => import("./components/Login"));
const TermsOfService = lazy(() => import("./components/TermsOfService"));
const BlogList = lazy(() => import("./components/BlogList"));
const ArticleHive = lazy(() => import("./components/ArticleHive"));
const PasswordReset = lazy(() => import("./components/PasswordReset"));
const ConfirmEmail = lazy(() => import("./components/ConfirmEmail"));
const ErrorPage = lazy(() => import("./components/ErrorPage"));

function PageLoader() {
  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      role="status"
      aria-live="polite"
    >
      <div className="text-center">
        <div
          className="spinner-border text-warning"
          aria-hidden="true"
        />

        <p className="mt-3 mb-0">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <ScrollToTopButton />

        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/opportunities" element={<Opportunities />} />
            <Route
              path="/hackathons"
              element={<Navigate to="/opportunities" replace />}
            />
            <Route path="/join-us" element={<JoinUs />} />
            <Route path="/our-elite" element={<OurElite />} />
            <Route path="/our-founders" element={<OurFounders />} />
            <Route path="/events" element={<Events />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/community" element={<Community />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/report" element={<Report />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/terms-of-service"
              element={<TermsOfService />}
            />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<ArticleHive />} />
            <Route
              path="/reset-password/:token"
              element={<PasswordReset />}
            />
            <Route
              path="/confirm-email/:token"
              element={<ConfirmEmail />}
            />

            <Route path="/home" element={<Navigate to="/" replace />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;